import { ReservationPublic } from '../../../containers/Reservation';

const ReservationPublicRoutes = [
  {
    path: '/reservation/public/:id',
    exact: true,
    component: ReservationPublic,
  },
];

export default ReservationPublicRoutes;
